import { z } from 'zod';

export const REASONS = {
  support: 'Support',
  sales: 'Sales',
  feedback: 'Feedback',
  other: 'Other',
};

const REASON_VALUES = ['support', 'sales', 'feedback', 'other'] as const satisfies ReadonlyArray<keyof typeof REASONS>;

export const contactUsFormSchema = z.object({
  reason: z.enum(REASON_VALUES),
  name: z.string().min(1, 'What should we call you?'),
  email: z.string().min(1, 'What email should we send a response to?'),
  message: z.string().min(1, 'Please provide some details so we can help'),
});

export type ContactUsFormData = z.infer<typeof contactUsFormSchema>;
